// 화면1 — 샷-제품 동기화 더미 데이터
// 목적: 공정·비전·열화상 3개 데이터가 "동일 제품(=같은 샷)"의 데이터인지 매칭 판단.
// 실제 API 연동 시 이 파일의 export 형태만 유지하고 내부를 교체하면 됨.

// 상단 요약 스탯
export const syncSummary = {
  totalShots: 1284,        // 총 샷 수
  matchRate: 98.7,         // 동일 제품 매칭률(%)
  avgConfidence: 96.2,     // 평균 매칭 신뢰도(%)
  mismatchCount: 6,        // 불일치(오매칭) 건수
};

// 타임라인 트랙 (가로축 = 시간 초, 3개 소스)
// 하나의 제품으로 매칭되는 3개 소스 이벤트가 세로 점선으로 연결됨
export const timelineTracks = [
  { source: 'process', labelKey: 'pages.moduleb.common.sources.process', color: '#3B82F6' },
  { source: 'vision', labelKey: 'pages.moduleb.common.sources.vision', color: '#22c55e' },
  { source: 'thermal', labelKey: 'pages.moduleb.common.sources.thermal', color: '#f97316' },
];

// 각 샷의 3개 소스 수신 위치(초 단위, 타임라인 x좌표) + 매칭 판단 결과
// matched: 각 소스가 해당 제품으로 매칭되었는지
export const timelineShots = [
  { shotId: 'S-10241', productId: 'P-8841', t: 2.1, matched: { process: true, vision: true, thermal: true }, status: 'match' },
  { shotId: 'S-10242', productId: 'P-8842', t: 6.4, matched: { process: true, vision: true, thermal: true }, status: 'match' },
  { shotId: 'S-10243', productId: 'P-8843', t: 10.7, matched: { process: true, vision: true, thermal: true }, status: 'match' },
  { shotId: 'S-10244', productId: 'P-8844', t: 15.0, matched: { process: true, vision: true, thermal: true }, status: 'check' },
  { shotId: 'S-10245', productId: 'P-8845', t: 19.3, matched: { process: true, vision: true, thermal: false }, status: 'mismatch' },
  { shotId: 'S-10246', productId: 'P-8846', t: 23.6, matched: { process: true, vision: true, thermal: true }, status: 'match' },
  { shotId: 'S-10247', productId: 'P-8847', t: 27.9, matched: { process: true, vision: true, thermal: true }, status: 'match' },
  { shotId: 'S-10248', productId: 'P-8848', t: 32.2, matched: { process: true, vision: true, thermal: true }, status: 'match' },
];

// 매칭 결과 배지 메타
export const syncStatusMeta = {
  match: { labelKey: 'pages.moduleb.sync.status.match', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  check: { labelKey: 'pages.moduleb.sync.status.check', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)' },
  mismatch: { labelKey: 'pages.moduleb.sync.status.mismatch', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// 최근 샷-제품 매칭 테이블 (15~20행)
// confidence = 3개 소스가 동일 제품일 매칭 신뢰도(%)
export const syncTable = [
  { shotId: 'S-10248', productId: 'P-8848', ts: '14:32:08.214', process: true, vision: true, thermal: true, confidence: 98.4, status: 'match' },
  { shotId: 'S-10247', productId: 'P-8847', ts: '14:32:03.918', process: true, vision: true, thermal: true, confidence: 97.1, status: 'match' },
  { shotId: 'S-10246', productId: 'P-8846', ts: '14:31:59.640', process: true, vision: true, thermal: true, confidence: 96.8, status: 'match' },
  { shotId: 'S-10245', productId: 'P-8845', ts: '14:31:55.301', process: true, vision: true, thermal: false, confidence: 61.2, status: 'mismatch' },
  { shotId: 'S-10244', productId: 'P-8844', ts: '14:31:51.077', process: true, vision: true, thermal: true, confidence: 88.5, status: 'check' },
  { shotId: 'S-10243', productId: 'P-8843', ts: '14:31:46.742', process: true, vision: true, thermal: true, confidence: 95.3, status: 'match' },
  { shotId: 'S-10242', productId: 'P-8842', ts: '14:31:42.418', process: true, vision: true, thermal: true, confidence: 97.6, status: 'match' },
  { shotId: 'S-10241', productId: 'P-8841', ts: '14:31:38.109', process: true, vision: true, thermal: true, confidence: 96.0, status: 'match' },
  { shotId: 'S-10240', productId: 'P-8840', ts: '14:31:33.820', process: true, vision: true, thermal: true, confidence: 98.9, status: 'match' },
  { shotId: 'S-10239', productId: 'P-8839', ts: '14:31:29.512', process: true, vision: true, thermal: true, confidence: 94.7, status: 'match' },
  { shotId: 'S-10238', productId: 'P-8838', ts: '14:31:25.233', process: true, vision: true, thermal: true, confidence: 97.2, status: 'match' },
  { shotId: 'S-10237', productId: 'P-8837', ts: '14:31:20.944', process: true, vision: false, thermal: true, confidence: 58.4, status: 'mismatch' },
  { shotId: 'S-10236', productId: 'P-8836', ts: '14:31:16.655', process: true, vision: true, thermal: true, confidence: 96.5, status: 'match' },
  { shotId: 'S-10235', productId: 'P-8835', ts: '14:31:12.367', process: true, vision: true, thermal: true, confidence: 93.8, status: 'match' },
  { shotId: 'S-10234', productId: 'P-8834', ts: '14:31:08.078', process: true, vision: true, thermal: true, confidence: 97.9, status: 'match' },
  { shotId: 'S-10233', productId: 'P-8833', ts: '14:31:03.789', process: true, vision: true, thermal: true, confidence: 95.1, status: 'match' },
  { shotId: 'S-10232', productId: 'P-8832', ts: '14:30:59.500', process: true, vision: true, thermal: true, confidence: 98.2, status: 'match' },
  { shotId: 'S-10231', productId: 'P-8831', ts: '14:30:55.211', process: true, vision: true, thermal: true, confidence: 90.4, status: 'check' },
];

// 선택된 샷의 매칭 상세 (매칭된 제품 + 소스별 식별키/신뢰도/일치여부)
export const syncDetailByShot = {
  'S-10248': {
    productId: 'P-8848',
    reference: '14:32:08.220',
    sources: [
      { source: 'process', labelKey: 'pages.moduleb.common.sources.process', key: 'CAV-A · cyc#8848', received: '14:32:08.209', confidence: 99.1, matched: true },
      { source: 'vision', labelKey: 'pages.moduleb.common.sources.vision', key: 'IMG · frame#41207', received: '14:32:08.217', confidence: 98.6, matched: true },
      { source: 'thermal', labelKey: 'pages.moduleb.common.sources.thermal', key: 'THM · frame#20873', received: '14:32:08.231', confidence: 97.4, matched: true },
    ],
  },
  'S-10245': {
    productId: 'P-8845',
    reference: '14:31:55.310',
    sources: [
      { source: 'process', labelKey: 'pages.moduleb.common.sources.process', key: 'CAV-A · cyc#8845', received: '14:31:55.298', confidence: 98.7, matched: true },
      { source: 'vision', labelKey: 'pages.moduleb.common.sources.vision', key: 'IMG · frame#41198', received: '14:31:55.306', confidence: 96.9, matched: true },
      { source: 'thermal', labelKey: 'pages.moduleb.common.sources.thermal', key: 'THM · ', keySuffixKey: 'pages.moduleb.sync.missing', received: '—', confidence: 0, matched: false },
    ],
  },
};

// 테이블 첫 행 기준 기본 선택 샷
export const defaultSyncShotId = 'S-10248';
